import PropTypes from 'prop-types';
import { Navbar, NavbarLink } from 'platfi-ui-components';

import ConnectedNavNotifications from '../ConnectedNavNotification/ConnectedNavNotification';

const LenderNavbar = (props) => {
  const { dark, fundingSearchCount, logoUrl, navMenu } = props;

  return (
    <Navbar
      dark={dark}
      logoUrl={logoUrl}
      mainLinks={
        <>
          <NavbarLink
            label="Dashboard"
            to="/funding"
            match={['/funding']}
            badge={fundingSearchCount || 0}
          />

          <NavbarLink label="Lending Criteria" to="/lender/criteria" match={['/lender/criteria']} />
        </>
      }
      navNotification={<ConnectedNavNotifications />}
      navMenu={navMenu}
    />
  );
};

LenderNavbar.propTypes = {
  dark: PropTypes.bool,
  fundingSearchCount: PropTypes.number,
  logoUrl: PropTypes.string,
  navMenu: PropTypes.node,
};

export default LenderNavbar;
